import { useClient, useLooseOrder, useTask, useUser, useUserId, useUsers } from 'reducers';
import API from '../../API';
import { message } from 'antd';
import moment from 'moment';

export const useNewTaskDetails = (id: number | undefined) => {
	const [task, refreshTask] = useTask(id);
	const [order, refreshOrder] = useLooseOrder(task?.orderId);
	const [client] = useClient(order?.clientId);
	const [assignedUser] = useUser(task?.assignedTo ?? undefined);
	const drivers = useUsers({});
	const userId = useUserId();

	const assign = async (assignee: number | null) => {
		try {
			await API.tasks.patch(id!, {
				assignedTo: assignee,
			});
			await refreshTask();
			await refreshOrder();

			message.success('Przypisano wykonawcę');
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się przypisać wykonawcy (${e})`);
		}
	};

	const take = async () => {
		try {
			await API.tasks.patch(id!, {
				assignedTo: userId!,
				takenAt: moment(),
			});
			await refreshTask();
			await refreshOrder();

			message.success('Zgłoszono do realizacji');
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się zgłosić do realizacji (${e})`);
		}
	};

	const resign = async () => {
		try {
			await API.tasks.patch(id!, {
				assignedTo: null,
			});
			await refreshTask();
			await refreshOrder();

			message.success('Wycofano z realizacji');
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się wycofać z realizacji (${e})`);
		}
	};

	return {
		task,
		order,
		client,
		assignedUser,
		drivers,
		assign,
		take,
		resign,
	};
};
